<template>
  <div class="py-2">
    <b-container
      fluid
      class="col-sm-11 col-lg-8 border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
    >
      <b-tabs
        active-nav-item-class="font-weight-bold text-white bg-secondary border-secondary rounded-0 no__hover"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3 "
        nav-class="text-secondary font-weight-bold border-bottom border-secondary px-0 nav_border"
        fill
        no-key-nav
        no-nav-style
        v-model="tabIndex"
      >
        <b-tab title="Dati Anagrafici" active>
          <div class="col-10 mx-auto" v-if="!msg">
            <b-overlay :show="loading" rounded="sm" spinner-variant="secondary">
              <b-form @submit="onSubmit">
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Nome:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.nome"
                      type="text"
                      id="nome"
                      :placeholder="user.anagrafica.nome"
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Cognome:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.cognome"
                      type="text"
                      id="cognome"
                      :placeholder="user.anagrafica.cognome"
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>
                  </b-col>
                </b-row>

                <b-row class="my-1 justify-content-around" v-if="user.anagrafica.categoria">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Categoria:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-select
                      id="specializzazione"
                      class="my-2"
                      v-model="user.anagrafica.categoria.id"
                      :options="categorie"
                      required
                      :disabled="disable"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Regione:</label>
                  </b-col>
                  <b-col sm="6">
                    <!-- <b-form-input
                        v-model="user.anagrafica.regione"
                        type="text"
                        id="regione"
                        :placeholder="user.anagrafica.regione"
                        class="my-2"
                        :disabled="disable"
                    ></b-form-input>-->
                    <b-form-select
                      id="regione"
                      class="my-2"
                      :placeholder="user.anagrafica.regione"
                      v-model="user.anagrafica.regione"
                      :disabled="disable"
                      :options="regioni"
                      @change="getProvincie"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Provincia:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-if="disable"
                      v-model="user.anagrafica.provincia"
                      type="text"
                      id="provincia"
                      :placeholder="user.anagrafica.provincia"
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>
                    <b-form-select
                      v-else
                      id="provincia"
                      :placeholder="user.anagrafica.provincia"
                      class="my-2"
                      :disabled="disable"
                      :options="province"
                      @change="getComuni"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Comune:</label>
                  </b-col>
                  <b-col sm="6">
                    <!-- <b-form-input
                      v-model="user.anagrafica.comune"
                      type="text"
                      id="comune"
                      :placeholder="user.anagrafica.comune"
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>-->
                    <b-form-select
                      id="comune"
                      class="my-2"
                      v-model="user.anagrafica.comune"
                      :disabled="disable"
                      :placeholder="user.anagrafica.comune"
                    >
                      <b-form-select-option
                        v-for="(comune, ind) in comuni"
                        :key="ind"
                        :value="comune.comune"
                      >{{ comune.comune }}</b-form-select-option>
                    </b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Indirizzo:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.indirizzo"
                      type="text"
                      id="indirizzo"
                      :placeholder="user.anagrafica.indirizzo"
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Telefono:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.telefono"
                      type="text"
                      id="telefono"
                      :placeholder="user.anagrafica.telefono"
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Cellulare:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.cellulare"
                      type="text"
                      id="cellulare"
                      :placeholder="
                        !this.user.anagrafica.cellulare && 'numero cellulare'
                      "
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>
                  </b-col>
                </b-row>

                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Codice Fiscale:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.cf"
                      type="text"
                      id="cf"
                      :placeholder="user.anagrafica.cf"
                      class="my-2 text-uppercase"
                      disabled
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Denominazione:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.denominazione"
                      type="text"
                      id="denominazione"
                      :placeholder="user.anagrafica.denominazione"
                      class="my-2"
                      :disabled="disable"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Partita Iva:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="user.anagrafica.partita_iva"
                      type="text"
                      id="partita_iva"
                      :placeholder="user.anagrafica.partita_iva"
                      class="my-2"
                      disabled
                    ></b-form-input>
                  </b-col>
                </b-row>

                <p v-if="error" class="text-danger">{{ error }}</p>

                <span
                  class="text-secondary edit__link pt-3"
                  v-if="this.disable"
                  @click="toggleEdit"
                >Modifica</span>
                <div v-else>
                  <b-button
                    type="button"
                    variant="outline-primary font-weight-bold mx-2"
                    @click="toggleEdit"
                  >Annulla</b-button>
                  <b-button type="submit" variant="primary font-weight-bold mx-2">Salva</b-button>
                </div>
              </b-form>
            </b-overlay>
          </div>
          <p v-else>{{ msg }}</p>
        </b-tab>
        <b-tab title="Orari Ricevimento" class="nav_border">
          <impostazione-orari />
        </b-tab>
        <b-tab title="Impostazioni" class="nav_border">
          <impostazioni :utente="this.user" />
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import ImpostazioneOrari from "@/components/ImpostazioneOrari";
import Impostazioni from "@/components/Impostazioni";
export default {
  name: "anagrafica-farmacista",
  props: ["utente"],
  components: {
    ImpostazioneOrari,
    Impostazioni
  },
  data() {
    return {
      user: this.utente,
      disable: true,
      msg: null,
      error: false,
      categorie: [],
      loading: false,
      regioni: null,
      province: null,
      comuni: null,
      tabIndex: 0
    };
  },
  watch: {},
  computed: {
    //
  },
  methods: {
    getCategorie() {
      var url =
        process.env.VUE_APP_VERSION + "categoria?ruolo=" + this.user.role;
      this.$axios
        .get(url)
        .then(res => {
          this.loading = false;
          res.data.data.forEach(element => {
            this.categorie.push({ text: element.nome, value: element.id });
          });
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    toggleEdit(e) {
      e.preventDefault();
      // console.log("clck");
      this.disable = !this.disable;
    },
    onSubmit(evt) {
      evt.preventDefault();
      !this.validate() && this.sendForm();
    },
    validate() {
      var check = Object.keys(this.user.anagrafica).some(val => {
        val != "cellulare" && this.user.anagrafica[val] == null;
      });
      if (check) {
        this.error = "nessun campo può essere vuoto";
      }
      return check;
    },
    sendForm() {
      this.loading = true;
      var url = process.env.VUE_APP_VERSION + this.user.role;
      this.$axios
        .put(url, this.user.anagrafica)
        .then(() => {
          this.loading = false;
          this.msg = "Operazione effettuata con successo!";
          var self = this;
          setInterval(function() {
            self.$router.go();
          }, 1000);
        })
        .catch(err => {
          this.loading = false;
          this.error = err.response;
        });
    },
    getRegioni() {
      var url = process.env.VUE_APP_VERSION + "regioni";
      this.$axios
        .get(url)
        .then(res => {
          this.regioni = res.data.data;
          this.getProvincie();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getProvincie() {
      var url = process.env.VUE_APP_VERSION + "province";
      if (this.user.anagrafica.regione) {
        url =
          process.env.VUE_APP_VERSION +
          "province/" +
          this.user.anagrafica.regione;
      }

      this.$axios
        .get(url)
        .then(res => {
          this.province = res.data.data;
          this.getComuni();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getComuni() {
      var url = process.env.VUE_APP_VERSION + "comuni";
      if (this.user.anagrafica.regione) {
        url =
          process.env.VUE_APP_VERSION +
          "comuni/regioni/" +
          this.user.anagrafica.regione;
        if (this.user.anagrafica.provincia) {
          url =
            process.env.VUE_APP_VERSION +
            "comuni/province/" +
            this.user.anagrafica.provincia;
        }
      }
      this.$axios
        .get(url)
        .then(res => {
          this.comuni = res.data.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    this.getCategorie();
    this.getRegioni();
  },
  mounted() {
    if (this.$route.query.toset == "orari") {
      this.tabIndex = 1;
      this.$router.replace({ name: "Profilo" });
    }
  }
};
</script>
<style>
li.nav-item > a {
  border-bottom: 2px solid #2b4473;
  color: #2b4473;
}
</style>